import type { ReactNode } from 'react';
import './chat-ui.css';

type ChatThreadLayoutProps = {
  children: ReactNode;
  className?: string;
};

function ChatThreadLayout({ children, className = '' }: ChatThreadLayoutProps) {
  return (
    <div className={`chat-thread-layout max-w-[48rem] w-full mx-auto px-5 md:px-6 ${className}`}>
      <div className="chat-thread-layout-inner flex flex-col gap-2 py-6 pb-32 w-full">
        {children}
      </div>
    </div>
  );
}

ChatThreadLayout.defaultProps = {
  className: '',
};

export default ChatThreadLayout;
